(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var row = event.target.closest('.book-faq__row');
    if (!row) return;

    var root = row.closest('[data-book-faq]');
    if (!root) return;

    var panel = document.getElementById(row.getAttribute('aria-controls'));
    var open = row.getAttribute('aria-expanded') === 'true';

    row.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function formatMoney(root, cents) {
      if (!cents) return '';
      var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return moneyFormat
        .replace(/\{\{amount\}\}/g, amount)
        .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
        .replace(/\{\{amount_no_decimals\}\}/g, Math.floor(cents / 100));
    }

    // --- Variant (language) buttons ---
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-book-buy-variant-btn]');
      if (!btn) return;

      var root = btn.closest('[data-book-buy-form]');
      if (!root) return;

      root.querySelectorAll('[data-book-buy-variant-btn]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var input = root.querySelector('[data-book-buy-variant-input]');
      if (input) input.value = btn.dataset.variantId;

      var priceEl = root.querySelector('[data-book-buy-price]');
      if (priceEl) priceEl.textContent = formatMoney(root, parseInt(btn.dataset.price, 10));

      var submitBtn = root.querySelector('[data-book-buy-submit]');
      if (submitBtn) {
        var available = btn.dataset.available === 'true';
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? submitBtn.dataset.label : submitBtn.dataset.soldOutLabel;
      }
    });

    // --- Quantity stepper ---
    document.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-book-buy-qty-minus]');
      var plus = event.target.closest('[data-book-buy-qty-plus]');
      if (!minus && !plus) return;

      var root = (minus || plus).closest('[data-book-buy-form]');
      var input = root && root.querySelector('[data-book-buy-qty-input]');
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      input.value = minus ? Math.max(1, value - 1) : value + 1;
    });

    // --- AJAX add to cart, per form instance ---
    document.addEventListener('submit', function (event) {
      var root = event.target.closest('[data-book-buy-form]');
      if (!root) return;

      event.preventDefault();

      var submitBtn = root.querySelector('[data-book-buy-submit]');
      var variantInput = root.querySelector('[data-book-buy-variant-input]');
      var qtyInput = root.querySelector('[data-book-buy-qty-input]');
      var cartUrl = root.dataset.cartUrl || '/cart';
      var originalLabel = submitBtn ? submitBtn.textContent.trim() : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantInput ? variantInput.value : null,
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalLabel;
            }
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-book-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-book-nav-spacer]');
      var bar = root.querySelector('[data-book-nav-bar]');
      if (!spacer || !bar || root.dataset.bookNavReady === 'true') return;
      root.dataset.bookNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--book-nav-top', offset + 'px');

        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        var height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');

        document.documentElement.style.setProperty('--book-nav-anchor-offset', (offset + height) + 'px');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-pages"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.book-pages').forEach(function (section) {
    var lightbox = section.querySelector('.book-pages__lightbox');
    if (!lightbox) return;

    var img = lightbox.querySelector('.book-pages__lightbox-img');
    var closeBtn = lightbox.querySelector('.book-pages__lightbox-close');

    function open(src, alt) {
      img.src = src;
      img.alt = alt || '';
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
    }

    function close() {
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      img.src = '';
    }

    section.querySelectorAll('.book-pages__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt);
      });
    });

    closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-themes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-book-themes-topic]');
    if (!btn) return;

    var root = btn.closest('[data-book-themes]');
    if (!root) return;

    var index = btn.dataset.index;

    root.querySelectorAll('[data-book-themes-topic]').forEach(function (t) {
      var active = t === btn;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-book-themes-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.index !== index;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var cartPage = document.getElementById('cart-page');
  if (!cartPage) return;

  var moneyFormat = cartPage.dataset.moneyFormat || '{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, Math.floor(cents / 100));
  }

  function setLoading(index, on) {
    var card = document.getElementById('cart-item-' + index);
    if (card) card.style.opacity = on ? '0.4' : '1';
  }

  function updateDOM(cart) {
    var itemMap = {};
    cart.items.forEach(function (item) {
      itemMap[item.key] = item;
    });

    document.querySelectorAll('[id^="cart-item-"]').forEach(function (card) {
      var lineKey = card.dataset.lineKey;
      var idx = card.id.replace('cart-item-', '');
      var updated = itemMap[lineKey];

      if (!updated) {
        card.remove();
        var row = document.getElementById('summary-item-' + idx);
        if (row) row.remove();
        return;
      }

      var linePrice = document.getElementById('line-price-' + idx);
      if (linePrice) linePrice.textContent = formatMoney(updated.final_line_price);

      var input = document.querySelector('input[data-line-key="' + lineKey + '"]');
      if (input) input.value = updated.quantity;

      var summaryPrice = document.getElementById('summary-price-' + idx);
      if (summaryPrice) summaryPrice.textContent = formatMoney(updated.final_line_price);

      var summaryQty = document.getElementById('summary-qty-' + idx);
      if (summaryQty) summaryQty.textContent = updated.quantity > 1 ? '× ' + updated.quantity : '';
    });

    var totalEl = document.getElementById('cart-total-price');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var headerTotal = document.getElementById('header-cart-total');
    if (headerTotal) headerTotal.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) window.location.reload();
  }

  function changeQuantity(lineKey, index, newQty) {
    setLoading(index, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { setLoading(index, false); updateDOM(data); })
      .catch(function () { setLoading(index, false); });
  }

  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var lineKey = btn.dataset.lineKey;
      var index = btn.dataset.index;
      var input = document.querySelector('input[data-line-key="' + lineKey + '"]');
      if (!input) return;
      var current = parseInt(input.value) || 0;
      var newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      input.value = newQty;
      changeQuantity(lineKey, index, newQty);
    });
  });

  var debounceTimers = {};
  document.querySelectorAll('input[data-line-key]').forEach(function (input) {
    input.addEventListener('change', function () {
      var lineKey = input.dataset.lineKey;
      var index = input.dataset.index;
      var newQty = Math.max(0, parseInt(input.value) || 0);
      clearTimeout(debounceTimers[lineKey]);
      debounceTimers[lineKey] = setTimeout(function () {
        changeQuantity(lineKey, index, newQty);
      }, 600);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function measureHeader() {
      var header = document.getElementById('site-header');
      var spacer = document.getElementById('site-header-spacer');
      if (!header || !spacer) return;
      var height = header.offsetHeight;
      spacer.style.height = height + 'px';
      document.documentElement.style.setProperty('--site-header-height', height + 'px');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', measureHeader);
    } else {
      measureHeader();
    }
    window.addEventListener('resize', measureHeader);
    window.addEventListener('load', measureHeader);
    document.addEventListener('shopify:section:load', measureHeader);
  })();

  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('mobile-menu-toggle');
    var close = document.getElementById('mobile-menu-close');
    var menu = document.getElementById('mobile-menu');
    var overlay = document.getElementById('mobile-menu-overlay');

    function openMenu() {
      menu.classList.remove('translate-x-full');
      overlay.classList.remove('opacity-0', 'pointer-events-none');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.add('translate-x-full');
      overlay.classList.add('opacity-0', 'pointer-events-none');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu && !menu.classList.contains('translate-x-full')) closeMenu();
    });

    var localeToggle = document.querySelector('.locale-selector-toggle');
    var localeDropdown = document.querySelector('.locale-selector-dropdown');
    var localeChevron = document.querySelector('.locale-chevron');

    if (localeToggle && localeDropdown) {
      localeToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = localeToggle.getAttribute('aria-expanded') === 'true';
        localeToggle.setAttribute('aria-expanded', String(!isOpen));
        localeDropdown.classList.toggle('opacity-0', isOpen);
        localeDropdown.classList.toggle('pointer-events-none', isOpen);
        localeDropdown.classList.toggle('translate-y-1', isOpen);
        if (localeChevron) localeChevron.style.transform = isOpen ? '' : 'rotate(180deg)';
      });

      document.addEventListener('click', function () {
        localeToggle.setAttribute('aria-expanded', 'false');
        localeDropdown.classList.add('opacity-0', 'pointer-events-none', 'translate-y-1');
        if (localeChevron) localeChevron.style.transform = '';
      });
    }

    var navToggle = document.querySelector('.jjp-nav-dropdown-toggle');
    var navPanel = document.querySelector('.jjp-nav-dropdown-panel');
    var navChevron = document.querySelector('.jjp-nav-dropdown-chevron');

    if (navToggle && navPanel) {
      navToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = navToggle.getAttribute('aria-expanded') === 'true';
        navToggle.setAttribute('aria-expanded', String(!isOpen));
        navPanel.classList.toggle('opacity-0', isOpen);
        navPanel.classList.toggle('pointer-events-none', isOpen);
        navPanel.classList.toggle('translate-y-1', isOpen);
        if (navChevron) navChevron.style.transform = isOpen ? '' : 'rotate(180deg)';
      });

      document.addEventListener('click', function () {
        navToggle.setAttribute('aria-expanded', 'false');
        navPanel.classList.add('opacity-0', 'pointer-events-none', 'translate-y-1');
        if (navChevron) navChevron.style.transform = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-main-sell-section"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.main-way-section').forEach(function (sectionEl) {
    var cartUrl  = sectionEl.dataset.cartUrl || '/cart';
    var langBtns = sectionEl.querySelectorAll('.way-lang-btn');
    var atcBtns  = sectionEl.querySelectorAll('.way-atc-btn');
    var priceEls = sectionEl.querySelectorAll('.way-price-display');

    langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        var price     = btn.dataset.price;

        langBtns.forEach(function (b) {
          if (b.dataset.variantId === variantId) {
            b.setAttribute('data-selected', 'true');
          } else {
            b.removeAttribute('data-selected');
          }
        });

        atcBtns.forEach(function (atcBtn) {
          atcBtn.dataset.variantId = variantId;
          atcBtn.disabled = false;
        });

        if (price) {
          priceEls.forEach(function (el) { el.textContent = price; });
        }
      });
    });

    atcBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || !btn.dataset.variantId) return;

        var variantId    = btn.dataset.variantId;
        var originalText = btn.dataset.label || btn.textContent.trim();
        var loadingText  = btn.dataset.loading || '…';

        atcBtns.forEach(function (b) {
          b.disabled = true;
          b.textContent = loadingText;
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              atcBtns.forEach(function (b) {
                b.textContent = originalText;
                b.disabled = false;
              });
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function () {
            atcBtns.forEach(function (b) {
              b.textContent = originalText;
              b.disabled = false;
            });
          });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-bio-education"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.jjp-bio-education__slides').forEach(function (slides) {
    var frames = slides.querySelectorAll('.jjp-bio-education__slide');
    if (frames.length < 2) return;

    var current = 0;
    setInterval(function () {
      frames[current].classList.remove('is-active');
      current = (current + 1) % frames.length;
      frames[current].classList.add('is-active');
    }, 2200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-book"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.jjp-book__slides').forEach(function (slides) {
    var frames = slides.querySelectorAll('.jjp-book__slide');
    if (frames.length < 2) return;

    var current = 0;
    setInterval(function () {
      frames[current].classList.remove('is-active');
      current = (current + 1) % frames.length;
      frames[current].classList.add('is-active');
    }, 2200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-ch-chronicle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.jjp-ch-chronicle__tab');
    if (!tab) return;

    var root = tab.closest('[data-jjp-ch-chronicle]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.jjp-ch-chronicle__tab'));
    var panels = root.querySelectorAll('.jjp-ch-chronicle__panel');
    var index = tabs.indexOf(tab);

    tabs.forEach(function (el, i) {
      var active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel, i) {
      panel.hidden = i !== index;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-ch-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var row = event.target.closest('.jjp-ch-faq__row');
    if (!row) return;

    var root = row.closest('[data-jjp-ch-faq]');
    if (!root) return;

    var panel = document.getElementById(row.getAttribute('aria-controls'));
    var open = row.getAttribute('aria-expanded') === 'true';

    row.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-ch-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var filterButton = event.target.closest('.jjp-ch-gallery__filter');
    if (filterButton) {
      var filterRoot = filterButton.closest('[data-jjp-ch-gallery]');
      if (!filterRoot) return;

      var filter = filterButton.getAttribute('data-filter');

      filterRoot.querySelectorAll('.jjp-ch-gallery__filter').forEach(function (el) {
        var active = el === filterButton;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      filterRoot.querySelectorAll('[data-breed]').forEach(function (card) {
        card.hidden = filter !== 'all' && card.getAttribute('data-breed') !== filter;
      });
      return;
    }

    var toggleButton = event.target.closest('[data-toggle]');
    if (toggleButton) {
      var toggleRoot = toggleButton.closest('[data-jjp-ch-gallery]');
      if (!toggleRoot) return;

      var card = toggleButton.closest('.jjp-ch-gallery__card');
      var panel = card ? card.querySelector('[data-titles]') : null;
      var willOpen = panel ? panel.hidden : false;

      toggleRoot.querySelectorAll('.jjp-ch-gallery__card').forEach(function (otherCard) {
        var otherPanel = otherCard.querySelector('[data-titles]');
        var otherToggle = otherCard.querySelector('[data-toggle]');
        if (!otherPanel || !otherToggle) return;

        var open = otherCard === card && willOpen;
        otherPanel.hidden = !open;
        otherToggle.classList.toggle('is-open', open);
        otherToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        otherToggle.textContent = open ? otherToggle.dataset.labelHide : otherToggle.dataset.labelShow;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-fl-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-fl-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-fl-nav-spacer]');
      var bar = root.querySelector('[data-jjp-fl-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpFlNavReady === 'true') return;
      root.dataset.jjpFlNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-fl-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-kika-chronology"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.jjp-kika-chronology__filter');
    if (!button) return;

    var root = button.closest('[data-jjp-chrono]');
    if (!root) return;

    var filter = button.getAttribute('data-filter');

    root.querySelectorAll('.jjp-kika-chronology__filter').forEach(function (el) {
      var active = el === button;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-decade]').forEach(function (card) {
      card.hidden = filter !== 'all' && card.getAttribute('data-decade') !== filter;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-kika-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-kika-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-kika-nav-spacer]');
      var bar = root.querySelector('[data-jjp-kika-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpKikaNavReady === 'true') return;
      root.dataset.jjpKikaNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-kika-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-kt-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-kt-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-kt-nav-spacer]');
      var bar = root.querySelector('[data-jjp-kt-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpKtNavReady === 'true') return;
      root.dataset.jjpKtNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-kt-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-kt-topics"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.jjp-kt-topics__tab');
    if (!tab) return;

    var root = tab.closest('[data-jjp-kt-topics]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.jjp-kt-topics__tab'));
    var panels = root.querySelectorAll('.jjp-kt-topics__panel');
    var index = tabs.indexOf(tab);

    tabs.forEach(function (el, i) {
      var active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel, i) {
      panel.hidden = i !== index;
    });
  });

  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-kt-topics]').forEach(setup);
    }

    function setup(root) {
      if (root.dataset.jjpKtReady === 'true') return;
      root.dataset.jjpKtReady = 'true';

      var dataEl = root.querySelector('[data-jjp-kt-topics-data]');
      var topics = [];
      try {
        topics = JSON.parse(dataEl.textContent);
      } catch (e) {
        topics = [];
      }

      var email = root.dataset.jjpKtEmail || '';
      var modal = root.querySelector('[data-jjp-kt-modal]');
      if (!modal) return;

      var form = modal.querySelector('[data-jjp-kt-form]') || modal.querySelector('form');
      if (!form) return;
      var formWrap = modal.querySelector('[data-jjp-kt-modal-form]');
      var sentWrap = modal.querySelector('[data-jjp-kt-modal-sent]');
      var topicLabel = modal.querySelector('[data-jjp-kt-modal-topic]');
      var topicSelect = modal.querySelector('[data-jjp-kt-field="topic"]');
      var topicHiddenField = modal.querySelector('[data-jjp-kt-field="topic-hidden"]');
      var messageField = modal.querySelector('[data-jjp-kt-field="message"]');
      var pointsLineEl = modal.querySelector('[data-jjp-kt-points-line]');
      var errorEl = modal.querySelector('[data-jjp-kt-error]');

      topics.forEach(function (topic, i) {
        var option = document.createElement('option');
        option.value = String(i);
        option.textContent = topic.name;
        topicSelect.appendChild(option);
      });

      function applyTopic(index) {
        var topic = topics[index];
        if (!topic) return;
        topicSelect.value = String(index);
        topicHiddenField.value = topic.name;
        topicLabel.textContent = topic.name;
        var points = topic.points || [];
        messageField.placeholder = points[0] || '';
        pointsLineEl.textContent = points.length
          ? 'Pravartu nurodyti: ' + points.join(' · ').toLowerCase() + '.'
          : '';
      }

      function openModal(index) {
        document.body.style.overflow = 'hidden';
        errorEl.hidden = true;
        errorEl.textContent = '';
        formWrap.hidden = false;
        sentWrap.hidden = true;
        applyTopic(index);
        modal.hidden = false;
      }

      function closeModal() {
        document.body.style.overflow = '';
        modal.hidden = true;
      }

      if (root.querySelector('[data-jjp-kt-posted]')) {
        document.body.style.overflow = 'hidden';
        formWrap.hidden = true;
        sentWrap.hidden = false;
        topicLabel.textContent = '';
        modal.hidden = false;
      }

      root.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-jjp-kt-open-form]');
        if (opener) {
          var index = parseInt(opener.getAttribute('data-topic-index'), 10) || 0;
          openModal(index);
          return;
        }

        if (event.target.closest('[data-jjp-kt-close]')) {
          closeModal();
        }
      });

      topicSelect.addEventListener('change', function () {
        applyTopic(parseInt(topicSelect.value, 10) || 0);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });

      function showError(text) {
        errorEl.textContent = text;
        errorEl.hidden = false;
      }

      if (root.querySelector('[data-jjp-kt-server-error]')) {
        openModal(0);
        showError('Nepavyko išsiųsti užklausos. Prašome pabandyti dar kartą arba rašykite tiesiogiai adresu ' + email + '.');
      }

      function validationError() {
        var name = form.querySelector('[data-jjp-kt-field="name"]').value.trim();
        var emailValue = form.querySelector('[data-jjp-kt-field="email"]').value.trim();
        var message = messageField.value.trim();

        if (!name) return 'Prašome nurodyti vardą.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
          return 'Prašome nurodyti teisingą el. pašto adresą.';
        }
        if (message.length < 10) return 'Prašome trumpai aprašyti savo klausimą.';
        return '';
      }

      // Submits natively: Shopify's hCaptcha adds its token on the real submit
      // event and may redirect to /challenge, neither of which works over fetch.
      form.addEventListener('submit', function (event) {
        var error = validationError();
        if (error) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError(error);
          return;
        }

        errorEl.hidden = true;
        errorEl.textContent = '';
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-pk-care"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var row = event.target.closest('.jjp-pk-layers__row');
    if (!row) return;

    var root = row.closest('[data-jjp-pk-accordion]');
    if (!root) return;

    var open = row.getAttribute('aria-expanded') === 'true';

    // One row open at a time, and clicking the open row closes it
    root.querySelectorAll('.jjp-pk-layers__row').forEach(function (el) {
      var expanded = el === row && !open;
      el.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      var panel = document.getElementById(el.getAttribute('aria-controls'));
      if (panel) panel.hidden = !expanded;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-pk-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-pk-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-pk-nav-spacer]');
      var bar = root.querySelector('[data-jjp-pk-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpPkNavReady === 'true') return;
      root.dataset.jjpPkNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-pk-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-pk-nutrition"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.jjp-pk-coats__tab');
    if (!tab) return;

    var root = tab.closest('[data-jjp-pk-tabs]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.jjp-pk-coats__tab'));
    var panels = root.querySelectorAll('.jjp-pk-coats__panel');
    var index = tabs.indexOf(tab);

    tabs.forEach(function (el, i) {
      var active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel, i) {
      panel.hidden = i !== index;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-tk-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-tk-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-tk-nav-spacer]');
      var bar = root.querySelector('[data-jjp-tk-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpTkNavReady === 'true') return;
      root.dataset.jjpTkNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-tk-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.jjp-video__play');
    if (!trigger || trigger.tagName !== 'BUTTON') return;

    var player = trigger.closest('.jjp-video__player');
    if (!player || player.classList.contains('is-playing')) return;

    var id = player.getAttribute('data-yt-id');
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0');
    iframe.setAttribute('title', player.getAttribute('data-yt-title') || 'YouTube');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');

    player.classList.add('is-playing');
    player.appendChild(iframe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-vs-achievements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-jjp-vs-more-toggle]');
    if (!toggle) return;

    var root = toggle.closest('[data-jjp-vs-more]');
    if (!root) return;

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    var next = !expanded;

    root.querySelectorAll('[data-jjp-vs-extra]').forEach(function (item) {
      item.hidden = !next;
    });

    toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
    toggle.textContent = next
      ? toggle.getAttribute('data-less-label')
      : toggle.getAttribute('data-more-label');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-vs-breeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.jjp-vs-breeds__tab');
    if (!tab) return;

    var root = tab.closest('[data-jjp-vs-tabs]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.jjp-vs-breeds__tab'));
    var panels = root.querySelectorAll('.jjp-vs-breeds__panel');
    var index = tabs.indexOf(tab);

    tabs.forEach(function (el, i) {
      var active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel, i) {
      panel.hidden = i !== index;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjp-vs-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-jjp-vs-nav]').forEach(setup);
    }

    function setup(root) {
      var spacer = root.querySelector('[data-jjp-vs-nav-spacer]');
      var bar = root.querySelector('[data-jjp-vs-nav-bar]');
      if (!spacer || !bar || root.dataset.jjpVsNavReady === 'true') return;
      root.dataset.jjpVsNavReady = 'true';

      var header = document.getElementById('site-header');
      var offset = 0;
      var height = 0;
      var queued = false;

      function measure() {
        offset = header ? header.offsetHeight : 0;
        bar.style.setProperty('--jjp-vs-nav-top', offset + 'px');

        // Read the bar's natural height while it is in flow, then hold it open
        var pinned = bar.classList.contains('is-pinned');
        if (pinned) bar.classList.remove('is-pinned');
        spacer.style.height = '';
        height = bar.offsetHeight;
        spacer.style.height = height + 'px';
        if (pinned) bar.classList.add('is-pinned');
      }

      function update() {
        queued = false;
        bar.classList.toggle('is-pinned', spacer.getBoundingClientRect().top <= offset);
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var article = document.querySelector('[data-money-format]');
  var moneyFormat = article ? article.dataset.moneyFormat : '{{amount}}';
  var cartUrl = article ? article.dataset.cartUrl : '/cart';

  function formatMoney(cents) {
    if (!cents) return '';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, Math.floor(cents / 100));
  }

  // --- Thumbnail switcher ---
  var mainImg = document.getElementById('product-main-image');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
      document.querySelectorAll('.product-thumb').forEach(function (t) {
        t.classList.remove('product-thumb--active');
      });
      thumb.classList.add('product-thumb--active');
    });
  });

  // --- Quantity stepper ---
  var qtyInput = document.getElementById('product-qty-input');
  var qtyMinus = document.getElementById('product-qty-minus');
  var qtyPlus  = document.getElementById('product-qty-plus');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, v - 1);
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
    });
  }

  // --- Variant price update ---
  var variantSelect = document.getElementById('product-variant-select');
  var priceEl        = document.getElementById('product-price');
  var comparePriceEl = document.getElementById('product-compare-price');
  var atcBtn         = document.getElementById('product-atc-btn');

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (priceEl) priceEl.textContent = formatMoney(parseInt(opt.dataset.price));
      if (comparePriceEl) {
        var cp = parseInt(opt.dataset.comparePrice);
        if (cp && cp > parseInt(opt.dataset.price)) {
          comparePriceEl.textContent = formatMoney(cp);
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('hidden');
        }
      }
      if (atcBtn) {
        var available = opt.dataset.available === 'true';
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? atcBtn.dataset.label : atcBtn.dataset.soldOutLabel;
      }
    });
  }

  // --- AJAX add to cart ---
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm && atcBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = variantSelect
        ? variantSelect.value
        : (productForm.querySelector('input[name="id"]') || {}).value;
      var qty = parseInt((qtyInput || {}).value) || 1;
      var originalLabel = atcBtn.textContent.trim();

      atcBtn.disabled = true;
      atcBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            atcBtn.disabled = false;
            atcBtn.textContent = originalLabel;
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
        });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
